import React from 'react'

const Footer = () => {
  return (
      <footer className="bg-gray-800 text-white py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <p>© 2025 Joi Jewelry. All rights reserved.</p>
              <div className="mt-4 flex justify-center space-x-4">
                  <a href="#" className="hover:text-amber-600">Contact</a>
                  <a href="#" className="hover:text-amber-600">About</a>
                  <a href="#" className="hover:text-amber-600">Terms</a>
              </div>
          </div>
      </footer>
  )
}

export default Footer